import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { ReactComponent as CalenderView } from '../../Assets/images/svg/dar_calender_view.svg';
import './commonCalendar.scss';

const CustomCalendarToolbar = ({ label, onNavigate }) => {
  const handlePrev = () => onNavigate('PREV');
  const handleNext = () => onNavigate('NEXT');
  const handleToday = () => onNavigate('TODAY');

  return (
    <div className="custom-calendar-toolbar">
      <IconButton onClick={handlePrev} size="small" className="chevron-icon">
        <ChevronLeft/>
      </IconButton>

      <IconButton className='calender-icon' onClick={handleToday} size="small">
        <CalenderView />
      </IconButton>

      <span>{label}</span>

      <IconButton onClick={handleNext} size="small" className="chevron-icon">
        <ChevronRight/>
      </IconButton>

    </div>
  );
};

CustomCalendarToolbar.propTypes = {
  label: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default CustomCalendarToolbar;
